import { RootState } from 'store';

export const selectSummary = (state: RootState) => state.summary;
